var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 174,
    viewBox: "0 0 128 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_7705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "easy-1",
    d: "M128 64C128 47.0263 121.257 30.7474 109.255 18.7454C97.2527 6.74297 80.9737 0 64 0C47.0263 0 30.7475 6.74297 18.7452 18.7449C6.74287 30.7474 0 47.0263 0 64H64H128Z",
    fill: "#CDD0D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-2",
    d: "M0 66H128V80H0V66Z",
    fill: "#8E9195"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 82.2002H128V94.2002H0V82.2002Z",
    fill: "#777A7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 98.4004H128V108.4H0V98.4004Z",
    fill: "#56585B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 114.6H128V122.6H0V114.6Z",
    fill: "#414345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 130.8H128V136.8H0V130.8Z",
    fill: "#37383B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-7",
    d: "M0 147H128V151H0V147Z",
    fill: "#313234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-8",
    d: "M0 162H128V164H0V162Z",
    fill: "#282A2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "easy-9",
    d: "M0 109C0 125.974 6.74297 142.253 18.7454 154.255C30.7473 166.257 47.0263 173 64 173C80.9737 173 97.2525 166.257 109.255 154.255C121.257 142.253 128 125.974 128 109L64 109H0Z",
    fill: "#282A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_7705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 174,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.5b504a13357d405693def8b698db5575.svg";
export { ForwardRef as ReactComponent };